import axios from "axios";
import { create } from "zustand";
import Cookies from "js-cookie";
import ReactPixel from "react-facebook-pixel";

const wishlistStore = create((set) => ({
  wishlistProduct: null,
  isLoading: true,

  setIsLoading: ({ value }) => {
    set({ isLoading: value });
  },

  setWishlistProductNull: () => {
    set({ wishlistProduct: null });
  },

  fetchAllWishlistProduct: async () => {
    try {
      const res = await axios.get("/site/fetch-all-user-wishlist");
      if (res.data.wishlistProduct.length) {
        set({ wishlistProduct: res.data.wishlistProduct });
      } else {
        set({ wishlistProduct: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
      set({ isLoading: false });
    }
  },

  addToWishlist: async ({ productID, productName, productPrice }) => {
    try {
      const res = await axios.post("/site/add-to-wishlist-product", {
        productID,
      });

      const { wishlistProduct } = wishlistStore.getState();
      const data = wishlistProduct ? wishlistProduct : [];
      data.push(res.data.wishlistProduct);
      set({ wishlistProduct: data });
      ReactPixel.track("AddToWishlist", {
        content_ids: [productID],
        content_name: productName,
        value: productPrice,
        currency: "INR",
      });
    } catch (error) {
      console.log(error);
    }
  },

  removeToWishlist: async ({
    wishlistID,
    productID,
    productName,
    productPrice,
  }) => {
    try {
      const { wishlistProduct } = wishlistStore.getState();
      const data = wishlistProduct.filter((item) => {
        return item._id !== wishlistID;
      });

      if (data.length === 0) {
        set({ wishlistProduct: null });
      } else {
        set({ wishlistProduct: data });
      }

      await axios.delete(`/site/remove-to-wishlist-product/${wishlistID}`);

      ReactPixel.track("RemoveToWishlist", {
        content_ids: [productID],
        content_name: productName,
        value: productPrice,
        currency: "INR",
      });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default wishlistStore;
